"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkipTLSVerification = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const TLSSettingsSection_1 = require("./TLSSettingsSection");
const SkipTLSVerification = ({ enabled, onToggle, readOnly }) => {
    return (react_1.default.createElement(TLSSettingsSection_1.TLSSettingsSection, { enabled: enabled, label: "Skip TLS certificate validation", tooltipText: "Skipping TLS certificate validation is not recommended unless absolutely necessary or for testing", onToggle: (newEnabled) => onToggle(newEnabled), readOnly: readOnly }));
};
exports.SkipTLSVerification = SkipTLSVerification;
//# sourceMappingURL=SkipTLSVerification.js.map